import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, {
      mask: Number,
      scale: 2,
      thousandsSeparator: ',',
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: '.',
      mapToRadix: ['.']
    })

    this.element.addEventListener('change', this.updateMask)
    document.addEventListener('turbo:morph', this.updateMaskValue)
    document.addEventListener('turbo:load', this.updateControl)
  }

  disconnect() {
    this.element.removeEventListener('change', this.updateMask)
    document.removeEventListener('turbo:morph', this.updateMaskValue)
    document.removeEventListener('turbo:load', this.updateControl)
  }

  updateMask = () => {
    this.element.dispatchEvent(new Event('blur'))
  }

  // Update the masked input when the page is loaded
  updateControl = () => {
    this.mask.updateControl()
  }

  // Update the masked input when the element is morphed
  updateMaskValue = () => {
    this.mask.updateValue()
  }
}
